/**
 * This model concern class decorator adds a recordPath function
 */

export interface HasRecordPath {
  /**
   * Returns the generic path to the record, e.g. /records/FEAT-123
   */
  recordPath(): string;
  /**
   * Returns the generic url to the record, e.g. https://bigaha.aha.io/records/FEAT-123
   */
  recordUrl(): string;
}

export function HasRecordPath<
  T extends { new (...args: any): { referenceNum: string } }
>(originalClass: T): T & { new (...args: any): HasRecordPath } {
  return class extends originalClass {
    recordPath(): string {
      return `/records/${this.referenceNum}`;
    }

    recordUrl(): string {
      return `${window.location.origin}${this.recordPath()}`;
    }
  };
}
